module.exports = __webpack_public_path__ + "static/media/error.2ecd24f7.wav";